import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showTable: false,
  activeBenefits: []
};

const topupSlice = createSlice({
  name: 'topup',
  initialState,
  reducers: {
    toggleShowTable: (state, { payload }) => {
      state.showTable = payload;
    },
    setActiveBenefits: (state, { payload }) => {
      state.activeBenefits = payload;
    }
  }
});

export const { reducer, actions: topupSliceActions } = topupSlice;
